'use client'

import { useMemo } from 'react'
import { selectAuxPowerLine, useRouteStore } from './route-store'

export type AuxPowerLine = NonNullable<ReturnType<typeof selectAuxPowerLine>>

/**
 * The generator/reefer add-on for the current estimate (or null). Reads the
 * primitive inputs separately and memoizes the derived line, so
 * components re-render only when one of them changes.
 */
export function useAuxPowerLine() {
	const estimate = useRouteStore((s) => s.estimate)
	const vehicleId = useRouteStore((s) => s.vehicleId)
	const auxPowerOn = useRouteStore((s) => s.auxPowerOn)
	const customGph = useRouteStore((s) => s.customGph)
	const auxIdleHours = useRouteStore((s) => s.auxIdleHours)
	return useMemo(
		() => selectAuxPowerLine({ estimate, vehicleId, auxPowerOn, customGph, auxIdleHours }),
		[estimate, vehicleId, auxPowerOn, customGph, auxIdleHours],
	)
}
